/**
 * Copyright 2025 Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { IActionHandlerInterceptor } from "sirius-platform-support-library/shared/actions/interceptors/action-handler-interceptor.interface";
import { Action } from "sirius-platform-support-library/models/common";
import { ActionMetadata } from "sirius-platform-support-library/shared/actions/action-metadata";
import { IAuthenticationService } from "sirius-platform-support-library/shared/authentication/authentication-service.interface";
import { StandardActions } from "sirius-platform-support-library/shared/micro-frontends/actions/standard-actions";

export const ActionHandlerInterceptorTypeName = "ActionHandlerInterceptor";

export class ActionHandlerInterceptor implements IActionHandlerInterceptor {
  private authenticationService: IAuthenticationService;

  public constructor(authenticationService: IAuthenticationService) {
    this.authenticationService = authenticationService;
  }

  public async intercept(
    context: any,
    source: string,
    action: Action,
    metadata?: ActionMetadata,
    fireActionPerformedEvent?: boolean
  ): Promise<undefined | boolean> {
    if (action.code === StandardActions.TITLE_LINK) {
      const userStatus =
        this.authenticationService.getUserContext()?.claims["userStatus"];
      const headerTitleActionRoute =
        userStatus?.toString()?.toUpperCase() !== "ACTIVE"
          ? "/portal"
          : "/dashboard";
      action.action = headerTitleActionRoute;
    }

    return undefined;
  }
}
